import React, { useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import { useCopyGroupHirerarchyModal } from "./useCopyGroupHirerarchyModal";
import "./copyGroupHirerarchy.scss";
import CopyInputField from "../../pages/integrations/singlewire/copyInputField";

const CopyGroupHirerarchyModal = ({ groupHierarchy }) => {
  const {
    showModel,
    copied,
    setCopied,
    handleClose,
    handleShow,
    setGroupHierarchy,
  } = useCopyGroupHirerarchyModal();

  useEffect(() => {
    setGroupHierarchy(groupHierarchy);
  }, []);

  return (
    <>
      <div className="" onClick={handleShow}>
        View Hirerarchy
      </div>

      <Modal
        show={showModel}
        onHide={handleClose}
        className="modal-container create-new-org-admin"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>View Group Hirerarchy</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CopyInputField
            text={groupHierarchy}
            copied={copied}
            setCopied={setCopied}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button className="button-bg-blue" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CopyGroupHirerarchyModal;
